import { saveSurveyApi } from "src/api/surveysAPI";
import { toPascal } from "../../utils/helpers";
import { handleResponse } from "src/services/apiServices";
import { trackPromise } from "react-promise-tracker";

export const saveSurvey = (survey: any, onSuccess: any) => {
  return async (dispatch: any, getState: any) => {
    const language = getState().lookup.language;

    const surveyPascal = toPascal(survey);

    trackPromise(
      saveSurveyApi(surveyPascal)
        .then((res) => {
          if (handleResponse(res, language)) onSuccess();
        })
        .catch((err) => {
          handleResponse(err, language);
        })
    );
  };
};
